import {z} from 'zod'
import {zQuestionCfgShape, zQuestionRow} from 'shared/forecast/question'
import {zCommentRow} from 'components/discussion/commentTypes'
import {zProfileCfg, zProfileRow} from 'components/portal/profileTypes'
import {pick} from 'remeda'
import {O} from 'ts-toolbelt'
import {match} from 'ts-pattern'

const zNotifyQuestionShape = pick(zQuestionCfgShape, ['title'])

export const zNotifyCommentCommon = z.object({
  question: zQuestionRow.pick({id: true}).extend(zNotifyQuestionShape),
  subquestion: zQuestionRow
    .pick({id: true})
    .extend(pick(zQuestionCfgShape, ['title']))
    .optional(),
  comment: zCommentRow.pick({id: true, cfg: true, created_at: true, created_by: true}),
  created_by: zProfileRow.pick({id: true}).merge(zProfileCfg.pick({name: true, avatar_url: true}))
})
export type NotifyCommentCommon = z.infer<typeof zNotifyCommentCommon>

const zNotifyQuestionChangedCommon = z.object({
  question: zQuestionRow.pick({id: true}).extend(zNotifyQuestionShape)
})

export const zNotifyCfg = z.discriminatedUnion('type', [
  zNotifyCommentCommon.extend({
    type: z.literal('comment-post')
  }),
  zNotifyCommentCommon.extend({
    type: z.literal('comment-reply')
  }),
  zNotifyCommentCommon.extend({
    type: z.literal('comment-mention')
  }),
  zNotifyQuestionChangedCommon.extend({type: z.literal('tasked')}),
  zNotifyQuestionChangedCommon.extend({type: z.literal('question-notify'), subject: z.string(), msg: z.string()}),
  z.object({type: z.literal('workspace-notify'), subject: z.string(), msg: z.string()})
])
export type NotifyCfg = z.infer<typeof zNotifyCfg>

export const zNotifyRow = z.object({
  id: z.string(),
  workspace_id: z.string(),
  created_at: z.string(),
  profile_id: z.string(),
  cfg: zNotifyCfg,
  archived: z.boolean().default(false),
  read: z.boolean().default(false)
})
export type NotifyRow = z.infer<typeof zNotifyRow>
export type NotifyType = NotifyRow['cfg']['type']

export type NotifyRowInsert = O.Optional<
  Pick<NotifyRow, 'cfg' | 'workspace_id' | 'profile_id' | 'created_at'>,
  'created_at'
>

export const zNotifyCommentMode = z.enum(['edit', 'new'])

export namespace NotifyCommentTypes {
  export const types = ['comment-post', 'comment-reply', 'comment-mention'] as const
  export type Type = (typeof types)[number]

  export const verb = (type: Type) =>
    match(type)
      .with('comment-post', () => 'posted')
      .with('comment-reply', () => 'replied')
      .with('comment-mention', () => 'mentioned')
      .exhaustive()

  export const relationToQuestion = (type: Type) =>
    match(type)
      .with('comment-post', () => 'on')
      .with('comment-reply', () => 'to you in')
      .with('comment-mention', () => 'you in')
      .exhaustive()

      
}
